import { ValidationError } from "yup";

export const isValidationError = (error: unknown): error is ValidationError =>
  error !== null &&
  typeof error === "object" &&
  "errors" in error &&
  "inner" in error;
